import "locomotive-scroll/dist/locomotive-scroll.css"
import "swiper/css"
import { initScroll, destroyScroll } from "./src/utils/scroll"

export const onInitialClientRender = () => {
    initScroll()
}

export const onRouteUpdate = () => {
    destroyScroll()
    initScroll()
}
